import React from 'react';
import { cn } from '@/lib/utils';
import CreateInvoiceStepItem from '@/components/molecules/invoice/CreateInvoiceStepItem';

interface Step {
  number: number;
  title: string;
}

interface CreateInvoiceStepsProps {
  activeStep: number;
  className?: string;
}

const CreateInvoiceSteps: React.FC<CreateInvoiceStepsProps> = ({ activeStep, className }) => {
  const steps: Step[] = [
    { number: 1, title: 'Upload Invoice' },
    { number: 2, title: 'Allocation' },
    { number: 3, title: 'Add Tag' }
  ];

  return (
    <div className={cn('card flex flex-col gap-10 py-5 px-6 relative', className)}>
      {steps.map((step) => (
        <CreateInvoiceStepItem
          key={step.number}
          stepNumber={step.number}
          title={step.title}
          isActive={activeStep === step.number}
          isCompleted={activeStep > step.number}
        />
      ))}

      {/* Connecting line between steps */}
      <div className="z-[0] absolute h-[calc(100%-45px)] w-[1.5px] bg-secondary top-[22px] bottom-5 left-9" />
    </div>
  );
};

export default CreateInvoiceSteps;
